/**
 * Calendar days on the business's clock — India Standard Time — whatever
 * timezone the viewer's computer is set to. A computer left on another zone
 * (one on US time showed "today" as yesterday) must not change which leads
 * "Today's Task" or "Today's Enquiries" show; the server counts by IST too
 * (backend/utils/dates.js).
 *
 * Days are passed around as 'YYYY-MM-DD' strings.
 */
import { format } from 'date-fns';

export const APP_TIME_ZONE = 'Asia/Kolkata';

const dayFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: APP_TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
});

/** 'YYYY-MM-DD' of a moment on the India calendar (default: now); '' for nothing. */
export function istDay(date = new Date()) {
  if (date === null || date === undefined || date === '') return '';
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  const parts = dayFormatter.formatToParts(d);
  const get = (t) => parts.find(p => p.type === t).value;
  return `${get('year')}-${get('month')}-${get('day')}`;
}

/** Today in India. */
export const todayIST = () => istDay();

/** A 'YYYY-MM-DD' day moved by n days. */
export function addDays(ymd, n) {
  const t = new Date(`${ymd}T00:00:00Z`);
  t.setUTCDate(t.getUTCDate() + n);
  return t.toISOString().slice(0, 10);
}

/** Yesterday in India. */
export const yesterdayIST = () => addDays(todayIST(), -1);

/** Whole days from day a to day b ('YYYY-MM-DD'); positive when b is later. */
export const daysBetween = (a, b) =>
  Math.round((Date.parse(`${b}T00:00:00Z`) - Date.parse(`${a}T00:00:00Z`)) / (24 * 3600 * 1000));

const wallFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: APP_TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
});

/**
 * Format a moment as it reads on an India clock, with a date-fns pattern —
 * "15 Oct, 18:16" for an activity logged at 18:16 IST, even on a computer
 * set to US time (where it would otherwise read 08:46). '' for nothing.
 */
export function formatIST(date, pattern) {
  if (date === null || date === undefined || date === '') return '';
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  const p = Object.fromEntries(wallFormatter.formatToParts(d).map(x => [x.type, x.value]));
  return format(new Date(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second), pattern);
}

/** Format a 'YYYY-MM-DD' day with a date-fns pattern, without timezone drift. */
export function formatDay(ymd, pattern) {
  if (!ymd) return '';
  const [y, m, d] = ymd.split('-').map(Number);
  return format(new Date(y, m - 1, d), pattern);
}
